import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModalInfo } from 'src/app/internal-models/common-models';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
  standalone:true,
})
export class ConfirmModalComponent {
  @Input() confirmModalInfo!: ConfirmModalInfo;

  constructor(public activeModal: NgbActiveModal) {
  }

}
